import axios from "axios";
import { config } from "./config";
import { tokens } from "./tokens";
import { handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
export const password = (() => {
    async function change(password) {
        try {
            const url = `${baseUrl()}`;
            const data = { password };
            const response = await axios.put(url, data);
            if (response.status === 200)
                return;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function request(email) {
        try {
            const url = `${baseUrl()}/reset/request`;
            const data = { email };
            const response = await axios.post(url, data);
            if (response.status === 200)
                return;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function confirm(token, password) {
        try {
            const _axios = axios.create();
            const url = `${baseUrl()}/reset/confirm`;
            const data = { password };
            const requestConfig = { headers: { Authorization: `Bearer ${token}` } };
            const response = await _axios.post(url, data, requestConfig);
            if (response && response.status === 200) {
                return tokens.set(response.headers);
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/password`;
    }
    return {
        change: change,
        request: request,
        confirm: confirm,
    };
})();
